import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SearchBarProps {
    placeholder: string;
    loading?: boolean;
    onChange: (searchTerm: string) => void;
    onClear: () => void;
    storedValue?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ placeholder, onChange, onClear, loading, storedValue }) => {
    const { t } = useTranslation();
    const inputRef = useRef<HTMLInputElement>(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [tooltipText, setTooltipText] = useState(''); 
    const [showTooltip, setShowTooltip] = useState(false);
    

    useEffect(() => {
        if (storedValue) {
            const storedSearch = localStorage.getItem(storedValue);
            if (storedSearch) {
                setSearchTerm(storedSearch);
            }
        }
    }, [storedValue]);

    const handleClear = () => {
        if (typeof window !== 'undefined') {
            localStorage.setItem(`${storedValue}`, ''); // Save email as a plain string
        }
        setSearchTerm('');
        setShowTooltip(false); // Hide tooltip
        onClear();
    };
    const handleInputChange = (value: string) => {

        
        if (typeof window !== 'undefined') {
            localStorage.setItem(`${storedValue}`, value); // Save email as a plain string
        }
        setSearchTerm(localStorage.getItem(`${storedValue}`) || value);
        onChange(value);

        // Update tooltip logic
        if (value.length > 0 && value.length < 3) {
            const charsNeeded = 3 - value.length;
            setTooltipText(`Type .${charsNeeded} more character${charsNeeded > 1 ? 's to search' : ''}`);
            setShowTooltip(true);
        } else {
            setShowTooltip(false);
        }
    };
    return (
        <div className={loading ? "searchMainDiv placeholder-glow" : "searchMainDiv"}>
            {loading ? <span className='searchBar placeholder w-100'> </span>  :
            <input
                type="text"
                ref={inputRef}
                className="form-control searchBar"
                placeholder={placeholder}
                value={searchTerm}
                onChange={(event) => {
                    handleInputChange(event.target.value)
                    onChange(event.target.value); // Trigger the onChange callback
                }}
            />}
            {searchTerm && (
                <div onClick={handleClear} className="clearIcon">
                    <i className="icon icon-x-circle-fill"></i>
                </div>
            )}
            <div className={loading ? "searchIcon placeholder-glow" : "searchIcon"}>
                {loading ? <span className='placeholder col-4 me-2'> </span> : <i className="icon icon-search"></i> } 
                {loading ? <span className='placeholder col-8'> </span> : <b>{t('SEARCH')}</b>}
            </div>
            {showTooltip && inputRef.current && (
                <div
                    className="custom-tooltip"
                    style={{
                        position: 'absolute',
                        top: `${inputRef.current.offsetTop + inputRef.current.offsetHeight + 5}px`,
                        left: `${inputRef.current.offsetLeft}px`,
                        zIndex: 1000,
                        backgroundColor: '#000000',
                        color: '#fff',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        fontSize: '0.875rem',
                        boxShadow: '0px 1px 4px 0px  rgba(12, 12, 13, 0.05)',
                        
                        whiteSpace: 'nowrap',
                    }}
                >
                    <div style={{ position: 'relative' }}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '-12px',
                                left: '-15px',
                                width: '0',
                                height: '0',
                                borderLeft: '5px solid transparent',
                                borderRight: '5px solid transparent',
                                borderBottom: '5px solid #000000',
                            }}
                        ></div>
                        {tooltipText}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchBar;
